module.exports = __webpack_public_path__ + "static/media/medalla-letra-M_1.e5f4c183.png";